import { AfterViewInit, Component, ElementRef, OnInit } from "@angular/core";
import { HTMLService } from "@services/htmlService.service";
import "./detail-page.component.scss";

@Component({
    selector: "detail-page",
    template: require("./detail-page.component.html")
})
export class DetailPageComponent implements OnInit, AfterViewInit {

    // ---

    constructor(
        private readonly elementRef: ElementRef,
        private readonly htmlService: HTMLService) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {

    }

    // ---
}
